export const seasonalRuleModalId = 'seasonal-rule-modal';

export const APPLIES_TO_FIELD_NAME = 'appliesTo';

export enum SeasonalRuleModalTab {
  PROPERTY_DETAILS = 'propertyDetails',
  PRICE_RULES = 'priceRules',
  CANCELLATION_POLICY = 'cancellationPolicy',
}
